import React from 'react';
import './Bouton.css'

const Bouton = (props) => {
    return (
        <div>
            <input type={props.type} value={props.value} className='submitLogin' disabled={props.disabled} onClick={props.onClick}/>
        </div>
    );
};

export default Bouton;